/**
 * Created by mukund on 11/10/15.
 */

'use strict';

angular.module('mediacloudApp')
    .factory('JobService', function ($resource, $http, $q) {
        return {
            CancelJob: $resource('api/job/:id', {id: '@id'}, {
                erase: {
                    method: 'DELETE', params: {}, isArray: false
                }
            }),
            GetUnpublished: $resource('api/job/unpublished'),
            CreateJob: function(){
                var service = {
                    job : null,
                    getNewJob : getNewJob
                };
                return service;
                // implementation
                function getNewJob(baseFile){
                    var def = $q.defer();
                    $http.post("api/job", baseFile)
                        .then(function (response) {
                            var result;
                            if(response.data){
                                result = response.data;
                            } else {
                                result = response;
                            }
                            service.job = result;
                            def.resolve(result);
                        }, function(error) {
                            def.reject("Failed to create new Job");
                        });
                    return def.promise;
                }
            }
        }
    });
